// extracted by mini-css-extract-plugin
module.exports = {"seasons":"Av","seasonsSelector":"Aw","oneSeasonSelector":"Ax","emblaViewport":"Ay","episodes":"Az","emblaSlide":"AA","textActive":"AB"};